var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons2ExportHandsupFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 23.8V13.5C16.2 12.2 17.2 11.2 18.5 11.2C19.8 11.2 20.8 12.2 20.8 13.5L21 24.5",
    fill: "#FDB614"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2 23.8V13.5C16.2 12.2 17.2 11.2 18.5 11.2C19.8 11.2 20.8 12.2 20.8 13.5L21 24.5",
    stroke: "#010101",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 25V10.5724C21 9.11842 21.8696 8 23 8C24.1304 8 25 9.11842 25 10.5724V25",
    fill: "#FDB614"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 25V10.5724C21 9.11842 21.8696 8 23 8C24.1304 8 25 9.11842 25 10.5724V25",
    stroke: "#010101",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30 24.5L31.9 19.9C32.3 18.7 33.6 18.1 34.8 18.5C36 18.9 36.6 20.2 36.2 21.4L35 24.9L31.7 33.4C31.1 34.9 30.3 36.2 29.1 37.3C27.2 39 24.8 40.1 22 40.1C16.3 40.1 11.6 35.5 11.6 29.7V29.6V16.8C11.6 15.6 12.6 14.5 13.9 14.5C14.5 14.5 15.1 14.8 15.5 15.2C15.9 15.6 16.2 16.2 16.2 16.8V23.8",
    fill: "#FDB614"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30 24.5L31.9 19.9C32.3 18.7 33.6 18.1 34.8 18.5C36 18.9 36.6 20.2 36.2 21.4L35 24.9L31.7 33.4C31.1 34.9 30.3 36.2 29.1 37.3C27.2 39 24.8 40.1 22 40.1C16.3 40.1 11.6 35.5 11.6 29.7V29.6V16.8C11.6 15.6 12.6 14.5 13.9 14.5C14.5 14.5 15.1 14.8 15.5 15.2C15.9 15.6 16.2 16.2 16.2 16.8V23.8",
    stroke: "#010101",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25 24.5V12.7C25 11.5 26.3 10.4 27.6 10.4C28.2 10.4 28.8 10.7 29.2 11.1C29.6 11.5 29.9 12.1 29.9 12.7V25",
    fill: "#FDB614"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25 24.5V12.7C25 11.5 26.3 10.4 27.6 10.4C28.2 10.4 28.8 10.7 29.2 11.1C29.6 11.5 29.9 12.1 29.9 12.7V25",
    stroke: "#010101",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons2ExportHandsupFilled);
export default __webpack_public_path__ + "static/media/icons-2_export-HANDSUP-FILLED.295f8437ea805c42e08241a40c435bef.svg";
export { ForwardRef as ReactComponent };